import api from "./core";
const config = require("./serverCfg").default;

const basePath = "api/core/Invoice";

export default {
  get(id, extraHeaders = null) {
    return api.get(`${basePath}/${id}`, extraHeaders);
  },
  getInvoiceEncounters(id, extraHeaders = null) {
    return api.get(`${basePath}/InvoiceEncounters`, extraHeaders);
  },
  query(filter, extraHeaders = null) {
    return api.post(`${basePath}`, filter, extraHeaders);
  },
  update(id, data, extraHeaders = null) {
    return api.patch(`${basePath}/${id}`, data, extraHeaders);
  },
  create(data, extraHeaders = null) {
    return api.post(`${basePath}/Add`, data, extraHeaders);
  },
  delete(id, extraHeaders = null) {
    return api.delete(`${basePath}/${id}`, extraHeaders);
  },
  invoiceViewUrl(invoiceId) {
    return {
      url: `${config.coreBaseUrl}${basePath}/RenderInvoice/${invoiceId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    };
  }
};
